module.exports = __webpack_public_path__ + "img/04_no.4d810851.svg";